import {
    ACTIONS,
    GenomTypes,
} from "../interfaces/index";

type InitialState = {
    loading: boolean;
    userDetails: Array<any>;
    bookingoverview: Array<any>;

};

const initialState: InitialState = {
    loading: false,
    userDetails: [],
    bookingoverview: [],


};

const GenomReducer = (
    state = initialState,
    action: GenomTypes
) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTIONS.GET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload,
                loading: false,
            };
            case ACTIONS.GET_BOOKING_OVERVIEW:
                return {
                    ...state,
                    bookingoverview: action.payload,
                    loading: false,
                };


        default:
            return state;
    }
};

export default GenomReducer;
